import _regeneratorRuntime from "/builds/WEB/apps/myecri-ui/node/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/builds/WEB/apps/myecri-ui/node/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function f() {
  return "usersnapCallback_".concat(Math.random().toString().slice(2));
}

function c(e, a, t) {
  return new Promise(function (n) {
    var o = f();

    if (e) {
      var d = t ? "&n=".concat(t) : "",
          w = "//widget.usersnap.com/".concat(a, "/load/").concat(e, "?onload=").concat(o).concat(d);

      if (!window[o]) {
        window[o] = function (l) {
          return delete window[o], n(l);
        };

        var r = document.createElement("script");
        r.defer = !0, r.nonce = t, r.onerror = function () {
          throw new Error("Wrong api key or paused project");
        }, r.src = w, document.head.appendChild(r);
      }
    }
  });
}

var s = /* @__PURE__ */new Map(),
    i = /* @__PURE__ */new Map(),
    u = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, a) {
    var t;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (e) {
              _context6.next = 2;
              break;
            }

            throw new Error("Missing api key");

          case 2:
            s.has(e) || s.set(e, c(e, "global", a));
            _context6.next = 5;
            return s.get(e);

          case 5:
            t = _context6.sent;
            return _context6.abrupt("return", {
              init: function () {
                var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(n) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return t.init(n);

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                function init(_x3) {
                  return _init.apply(this, arguments);
                }

                return init;
              }(),
              logEvent: function () {
                var _logEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(n) {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return t.logEvent(n);

                        case 2:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                function logEvent(_x4) {
                  return _logEvent.apply(this, arguments);
                }

                return logEvent;
              }(),
              show: function () {
                var _show = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(n) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return t.show(n);

                        case 2:
                          return _context3.abrupt("return", _context3.sent);

                        case 3:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                function show(_x5) {
                  return _show.apply(this, arguments);
                }

                return show;
              }(),
              hide: function () {
                var _hide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(n) {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return t.hide(n);

                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                function hide(_x6) {
                  return _hide.apply(this, arguments);
                }

                return hide;
              }(),
              destroy: function () {
                var _destroy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return t.destroy();

                        case 2:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));

                function destroy() {
                  return _destroy.apply(this, arguments);
                }

                return destroy;
              }(),
              on: function on(n, o) {
                t.on(n, o);
              },
              off: function off(n, o) {
                t.off(n, o);
              }
            });

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function u(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(),
    h = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e, a) {
    var t;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (e) {
              _context8.next = 2;
              break;
            }

            throw new Error("Missing api key");

          case 2:
            i.has(e) || i.set(e, c(e, "embed", a));
            _context8.next = 5;
            return i.get(e);

          case 5:
            t = _context8.sent;
            return _context8.abrupt("return", {
              init: function () {
                var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(n) {
                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return t.init(n);

                        case 2:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                }));

                function init(_x9) {
                  return _init2.apply(this, arguments);
                }

                return init;
              }(),
              on: function on(n, o) {
                t.on(n, o);
              },
              off: function off(n, o) {
                t.off(n, o);
              }
            });

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function h(_x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

export { h as loadEmbed, u as loadSpace };